import { ROUTE_PATHS } from '../config/route.config.js'

import accountRoutes from './routes/account.js'
import adminRoutes from './routes/admin.js'
import groupRoutes from './routes/group.js'

/**
 * Top-level route table. Auth pages wrap `DefaultLayout` internally; account /
 * group / admin branches use their layout wrappers. User pages (`/notifications`,
 * `/profile`) are flat routes — views own their shell via `AuthenticatedShell`.
 */
export default [
  {
    path: ROUTE_PATHS.login,
    name: 'Login',
    component: () => import('../views/LoginPage.vue'),
    meta: { requiresGuest: true, title: 'Kirjaudu - Vuokranet' },
  },
  {
    path: ROUTE_PATHS.forgotPassword,
    name: 'ForgotPassword',
    component: () => import('../views/PasswordPage.vue'),
    meta: { requiresGuest: true, title: 'Unohtuiko salasana? - Vuokranet' },
  },
  {
    path: ROUTE_PATHS.maintenance,
    name: 'Maintenance',
    component: () => import('../views/MaintenancePage.vue'),
    meta: { title: 'Huoltokatko - Vuokranet' },
  },
  {
    path: ROUTE_PATHS.account,
    component: () => import('../layouts/AccountLayout.vue'),
    meta: { requiresAuth: true },
    children: accountRoutes,
  },
  {
    path: ROUTE_PATHS.group,
    component: () => import('../layouts/GroupLayout.vue'),
    meta: { requiresAuth: true, requiresGroupMode: true },
    children: groupRoutes,
  },
  {
    path: ROUTE_PATHS.admin,
    component: () => import('../layouts/AdminLayout.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
    children: adminRoutes,
  },
  {
    path: ROUTE_PATHS.notifications,
    name: 'Notifications',
    component: () => import('../views/NotificationsPage.vue'),
    meta: {
      requiresAuth: true,
      scopeNeutral: true,
      title: 'Ilmoitukset - Vuokranet',
    },
  },
  {
    path: ROUTE_PATHS.profile,
    name: 'Profile',
    component: () => import('../views/ProfilePage.vue'),
    meta: {
      requiresAuth: true,
      scopeNeutral: true,
      title: 'Profiili - Vuokranet',
    },
  },
  {
    path: ROUTE_PATHS.pdfViewer,
    name: 'PdfViewer',
    component: () => import('../views/PdfViewerPage.vue'),
    meta: {
      requiresAuth: true,
      scopeNeutral: true,
      title: 'PDF - Vuokranet',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/overview',
  },
]
